var configs = {
    offset: {
        button: {
            x: -5,
            y: 5
        },
        viewport: {
            x: 20,
            y: 20
        }
    },
    height: {
        max: 880
    },
    width: {
        max: 440
    }
};
export default configs;



//////////////////
// WEBPACK FOOTER
// ../~/mmenu-js/dist/addons/dropdown/_configs.js
// module id = 61
// module chunks = 0